document.addEventListener('DOMContentLoaded', function () {
  var navToggle = document.querySelector('.visionary-nav-toggle');
  var nav = document.querySelector('.visionary-nav');

  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      nav.classList.toggle('visionary-nav--open');
    });
  }

  document.querySelectorAll('.visionary-variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.visionary-variant-buttons');
      if (!group) return;
      group.querySelectorAll('.visionary-variant-btn').forEach(function (b) {
        b.classList.remove('visionary-variant-btn--active');
      });
      btn.classList.add('visionary-variant-btn--active');
    });
  });
});

// V9 enhancements
document.addEventListener('DOMContentLoaded', function () {
  // Slideshow fade rotation
  var slideWrapper = document.querySelector('.visionary-slideshow-wrapper');
  var slides = document.querySelectorAll('.visionary-slideshow .visionary-slide, .visionary-slideshow-wrapper .visionary-slide');
  if (slides.length > 0 && slideWrapper) {
    var idx = 0;
    slides[0].classList.add('is-active');
    setInterval(function () {
      if (window.innerWidth <= 768) return; // no fade rotation on mobile stack
      slides[idx].classList.remove('is-active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
    }, 5000);
  }

  // Parallax
  var parallaxes = document.querySelectorAll('.visionary-parallax');
  function handleParallax() {
    var scrollY = window.scrollY || window.pageYOffset;
    parallaxes.forEach(function (el) {
      var speed = parseFloat(el.getAttribute('data-parallax-speed') || '0.2');
      var y = scrollY * speed * -0.15;
      el.style.transform = 'translateY(' + y + 'px)';
    });
  }
  window.addEventListener('scroll', handleParallax);
  handleParallax();

  // Drop countdown
  var dropBar = document.querySelector('.visionary-dropbar');
  if (dropBar) {
    var target = dropBar.getAttribute('data-target');
    var targetDate = target ? new Date(target) : null;
    if (targetDate && !isNaN(targetDate)) {
      var ddEl = dropBar.querySelector('[data-dd]');
      var hhEl = dropBar.querySelector('[data-hh]');
      var mmEl = dropBar.querySelector('[data-mm]');
      var ssEl = dropBar.querySelector('[data-ss]');
      function tick() {
        var now = new Date();
        var diff = targetDate - now;
        if (diff <= 0) diff = 0;
        var sec = Math.floor(diff / 1000);
        var d = Math.floor(sec / 86400); sec -= d*86400;
        var h = Math.floor(sec / 3600); sec -= h*3600;
        var m = Math.floor(sec / 60); var s = sec - m*60;
        if (ddEl) ddEl.textContent = String(d).padStart(2,'0') + 'd';
        if (hhEl) hhEl.textContent = String(h).padStart(2,'0') + 'h';
        if (mmEl) mmEl.textContent = String(m).padStart(2,'0') + 'm';
        if (ssEl) ssEl.textContent = String(s).padStart(2,'0') + 's';
      }
      tick();
      setInterval(tick, 1000);
    }
  }
});

// V10: culture slideshow, early access popup, drop-mode accent
document.addEventListener('DOMContentLoaded', function () {
  // Culture slideshow fade
  (function() {
    var wrapper = document.querySelector('.visionary-slideshow-wrapper');
    if (!wrapper) return;
    var slides = wrapper.querySelectorAll('.visionary-slide');
    if (!slides.length) return;
    var index = 0;
    function setActive(i) {
      slides.forEach(function(slide, idx) {
        slide.classList.toggle('is-active', idx === i);
      });
    }
    setActive(0);
    setInterval(function() {
      if (window.innerWidth <= 768) return; // stacked on mobile
      index = (index + 1) % slides.length;
      setActive(index);
    }, 5000);
  })();

  // Early access popup (once per browser)
  (function() {
    var popup = document.querySelector('[data-visionary-popup]');
    if (!popup) return;
    var SEEN_KEY = 'visionary_early_access_seen_v1';
    if (localStorage.getItem(SEEN_KEY)) return;
    function closePopup() {
      popup.classList.remove('is-active');
      localStorage.setItem(SEEN_KEY, '1');
    }
    popup.classList.add('is-active');
    popup.addEventListener('click', function(e) {
      if (e.target.hasAttribute('data-visionary-popup-close')) {
        e.preventDefault();
        closePopup();
      }
    });
  })();

  // If drop countdown exists, enable drop-mode accents
  (function() {
    var drop = document.querySelector('.visionary-dropbar');
    if (!drop) return;
    document.body.classList.add('visionary-drop-mode');
  })();
});

// V10.1: magnetic button spotlight
document.addEventListener('DOMContentLoaded', function() {
  var buttons = document.querySelectorAll('.visionary-btn');
  buttons.forEach(function(btn) {
    btn.addEventListener('mousemove', function(e) {
      var rect = btn.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      btn.style.setProperty('--vx', x + '%');
      btn.style.setProperty('--vy', y + '%');
    });
  });
});


// Visionary product gallery thumbnails
document.addEventListener('DOMContentLoaded', function () {
  var galleries = document.querySelectorAll('.visionary-product-gallery');
  if (!galleries.length) return;

  galleries.forEach(function (gallery) {
    var mainImage = gallery.querySelector('.visionary-product-main-image');
    if (!mainImage) return;

    var thumbs = gallery.querySelectorAll('.visionary-product-thumb');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (full) {
          mainImage.setAttribute('src', full);
        }

        thumbs.forEach(function (other) {
          other.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  });
});


/* === Vi$ionary Product Gallery (arrows + swipe) === */
(function(){
  const galleries = document.querySelectorAll('[data-visionary-gallery]');
  if(!galleries.length) return;

  galleries.forEach(gallery => {
    const mainImg = gallery.querySelector('[data-visionary-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-visionary-gallery-thumb]'));
    const prevBtn = gallery.querySelector('[data-visionary-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-visionary-gallery-next]');
    if(!mainImg || !thumbs.length) return;

    let index = Math.max(0, thumbs.findIndex(t => t.classList.contains('active')));
    if(index < 0) index = 0;

    function setActive(i){
      index = (i + thumbs.length) % thumbs.length;
      const t = thumbs[index];
      const full = t.getAttribute('data-full');
      if(full) mainImg.src = full;
      thumbs.forEach(x => x.classList.remove('active'));
      t.classList.add('active');
    }

    // Ensure thumb click also updates index
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => setActive(i));
    });

    if(prevBtn) prevBtn.addEventListener('click', () => setActive(index - 1));
    if(nextBtn) nextBtn.addEventListener('click', () => setActive(index + 1));

    // Swipe on mobile
    let startX = null;
    mainImg.addEventListener('touchstart', (e) => {
      startX = e.touches && e.touches[0] ? e.touches[0].clientX : null;
    }, {passive:true});
    mainImg.addEventListener('touchend', (e) => {
      if(startX == null) return;
      const endX = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : null;
      if(endX == null) return;
      const dx = endX - startX;
      if(Math.abs(dx) > 35){
        setActive(dx > 0 ? (index - 1) : (index + 1));
      }
      startX = null;
    }, {passive:true});
  });
})();
